import { render, staticRenderFns } from "./WallSettingsView.vue?vue&type=template&id=d890d9e4&scoped=true&"
import script from "./WallSettingsView.vue?vue&type=script&lang=js&"
export * from "./WallSettingsView.vue?vue&type=script&lang=js&"
import style0 from "./WallSettingsView.vue?vue&type=style&index=0&id=d890d9e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d890d9e4",
  null
  
)

export default component.exports